// extracted by mini-css-extract-plugin
export default {"heading":"hx-z","signin":"ix-z","signupBtn":"jx-z","disabled":"kx-z"};